import axios from 'axios'
import { getToken, removeToken } from '@/services/auth'
import { tansParams } from '@/services/base'
import cache from '@/services/cache'
import { ElMessage, ElMessageBox } from 'element-plus'
import eventBus from '@/utils/eventBus.js'
import { t } from '@/utils/i18n'

// 获取当前环境
const isProd = import.meta.env.MODE === 'production'

// 创建axios实例
const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL + "/api",
  timeout: 10000,
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
})

// request拦截器
api.interceptors.request.use(config => {
  console.log('Request:', {
    url: config.url,
    method: config.method,
    data: config.data,
    headers: config.headers
  })

  const isToken = (config.headers || {}).isToken === false
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  if (getToken() && !isToken) {
    console.log('🔑 Using token for request:', getToken()?.substring(0, 20) + '...')
    console.log('🔑 Full token length:', getToken()?.length)
    config.headers['Authorization'] = 'Bearer ' + getToken()
  } else {
    console.log('❌ No token available for request')
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params)
    url = url.slice(0, -1)
    config.params = {}
    config.url = url
  }
  // 防重复提交
  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const requestSize = Object.keys(JSON.stringify(requestObj)).length
    const limitSize = 5 * 1024 * 1024
    if (requestSize >= limitSize) {
      console.warn(`[${config.url}]: 请求数据大小超出允许的5M限制，无法进行防重复提交验证。`)
      return config
    }
    const sessionObj = cache.session.getJSON('sessionObj')
    if (!sessionObj) {
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url
      const s_data = sessionObj.data
      const s_time = sessionObj.time
      const interval = 1000
      if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        const message = '数据正在处理，请勿重复提交'
        console.warn(`[${s_url}]: ` + message)
        return Promise.reject(new Error(message))
      } else {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
  }
  return config
}, error => {
  console.error('Request error:', error)
  return Promise.reject(error)
})

// 响应拦截器
api.interceptors.response.use(
  res => {
    console.log('Response111:', {
      url: res.config.url,
      status: res.status,
      data: res.data,
      baseurl: res.config.baseURL

    })
    console.log('Response headers:')

    // 检查返回数据中的 code 字段
    if (res.data && res.data.code === 401) {
      console.log('🚨 Token expired detected in response:', res.data)
      console.log('🚨 Current token:', getToken()?.substring(0, 20) + '...')
      // Token 过期处理 - 显示确认对话框
      TokenExpired()

      return Promise.reject(new Error('Token expired'))
    }

    return res.data
  },
  error => {
    console.error('Response error:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url
    })

    // 检查 HTTP 状态码 401
    if (error.response?.status === 401) {
      // Token 过期处理 - 显示确认对话框
      TokenExpired()
    }

    return Promise.reject(error)
  }
)

// 测试 401 处理的函数
export const TokenExpired = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('userInfo')
  sessionStorage.clear()
  removeToken()
  eventBus.emit('update-login-status')
  // 显示确认对话框
  ElMessageBox.confirm(
    t('loginRegister.unauthorized'),
    t('loginRegister.unauthorizedTitle'),
    {
      confirmButtonText: t('loginRegister.reLogin'),
      cancelButtonText: t('loginRegister.cancel'),
      type: 'warning',
    }
  ).then(() => {
    // 用户点击确认
    eventBus.emit('show-login')
    return Promise.resolve()
  }).catch(() => {
    // 用户点击取消
    console.log('User cancelled test re-login')
    return Promise.resolve()
  })
}

export default api